import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonIcon,
  IonLabel,
  IonTitle,
  IonToolbar,
  useIonViewDidEnter} from '@ionic/react';
import { closeCircle } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import DismissibleMessageService from '../../services/DismissibleMessageService';
import './DismissibleCard.scss';
interface IDismissibleCardProps {
  messageId: string,
  hideCard?: boolean,
  buttonText?: string,
  color?: colorOptionType,
  dismissCard: (messageId: string, initiateAction: boolean) => void,
  children: JSX.Element,
}

type colorOptionType = 'prayer' |  'bible' | 'fellowship';

const DismissibleCard: React.FC<IDismissibleCardProps> = (props) => {
  const [hideCard, setHideCard] = useState(true);
  const [checkDB, setCheckDB] = useState(true);

  useIonViewDidEnter(() => {
    console.log('Dismissible Card - useIonView', props.messageId, `check DB: ${checkDB}, Hide: ${hideCard}`);
    if(checkDB) {
      DismissibleMessageService.getDismissibleMessage(props.messageId).then(result => {
        console.log('Dismissible Card - useIonView', result);
        if(result.Success) {
          setCheckDB(false);
          setHideCard(true);
        } else {
          setHideCard(false);
          console.log('Dismissible Card ' + props.messageId + ' not found.');
        }
      });
    }
  }, [props, checkDB]);

  useEffect(() => {
    console.log('Dismissible Card - useEffect', props.messageId, checkDB);
    if(checkDB) {
      DismissibleMessageService.getDismissibleMessage(props.messageId).then(result => {
      console.log('Dismissible Card - useEffect', result);
      if(result.Success) {
        setCheckDB(false);
        setHideCard(true);
      } else {
        setHideCard(false);
        console.log('Dismissible Card ' + props.messageId + ' not found.');
      }
    });
    }
    
    return () => {}
  }, [])
  

  return (
    <div hidden={hideCard ? true : props.hideCard}>
      <IonCard className="dismissible-card">
          <IonCardHeader className="dismissible-card-header">
            <IonToolbar mode='md' className="dismissible-card-toolbar">
              <IonTitle></IonTitle>
                <IonIcon slot='end' icon={closeCircle} className={props.color}
              onClick={() => props.dismissCard(props.messageId, false)}></IonIcon>
            </IonToolbar>
          </IonCardHeader>
        <IonCardContent>
          <div className={props.color}>
            {props.children}
          </div>
          { props.buttonText &&
            <IonButton expand="block" className={"dismissible-card-button " + props.color} onClick={() => props.dismissCard(props.messageId, true)}>
              <IonLabel>{props.buttonText}</IonLabel>
            </IonButton> 
          }
        </IonCardContent>
      </IonCard>
    </div>
  );
};

export default DismissibleCard;